import { fabric } from 'fabric';
import { b64toBlob, exportIMG } from '~core';
import { getState } from '~src/state';
import { cleanBase64 } from '~src/utils';
import Swal from 'sweetalert2';
import { getUser } from '~src/user';
import { showSidebarTab } from '~src/sidebarLegacy';
import { closeNavbarSubmenu } from '~core/navbar/submenus';
import { imageObjectToDataURL } from '~core/image';

export const handleExportToAttachment = async () => {
  // we need to toggle all magic frame editing modes off otherwise the editingImg gets exported in editing mode
  // also, we preserve the activeObject as when toggling the mode, the active object is unset
  const preservedActiveObject = window.canvas.getActiveObject();
  for (const object of window.canvas.getObjects()) {
    if (object.type === 'MagicFrame') {
      object.setEditMode(false);
    }
  }
  window.canvas.setActiveObject(preservedActiveObject);

  const { user } = await getUser();
  if (user.org_pointer.tipo_istanza === 'demo') {
    Swal.fire({
      title: 'Attenzione!',
      html:
        'Non &egrave; possibile esportare immagini durante il periodo di prova. Contattaci per maggiori informazioni.',
      icon: 'warning',
      showCancelButton: false,
      showCloseButton: true,
      confirmButtonText: 'Chiudi',
      confirmButtonColor: '#278e8e',
    });
    return;
  }

  let selection = window.canvas.getActiveObject();
  let blob;

  Swal.fire({
    text: "Sto esportando l'immagine...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    confirmButtonColor: '#278e8e',
    didOpen: () => {
      Swal.showLoading();
    },
  });

  if (selection) {
    // fix to support selection of a single MagicFrame
    // in that case we add an invisible text object to the selection
    if (selection.type === 'MagicFrame') {
      const invisibleText = new fabric.Textbox('', {
        left: selection.left,
        top: selection.top,
        width: 0,
        height: 0,
      });
      selection = new fabric.ActiveSelection([selection, invisibleText], {
        canvas: window.canvas,
      });
    }
    const imageBase64 = cleanBase64(await imageObjectToDataURL(selection));
    blob = b64toBlob(imageBase64.base64, imageBase64.contentType);
  } else {
    const project = getState('selected.tipo');
    const image = exportIMG(
      1,
      project.outputDpi,
      'blob',
      'png',
      false,
      project.multiplier || 1
    );
    blob = image.blob;
  }
  const attachmentsUploader = getState('uploader.allegati');

  attachmentsUploader.addFile({
    type: 'image/png',
    data: blob,
  });

  await attachmentsUploader.upload();
  attachmentsUploader.cancelAll();

  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: "L'immagine &egrave; stata allegata.",
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
  setTimeout(() => {
    Swal.close();
  }, 2000);
  showSidebarTab('allegati');
  closeNavbarSubmenu('export');
};

window.exportToAttachment = handleExportToAttachment;
